import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, Chip, Stack } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import { fetchStrategicIssues } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

export default function StrategicIssueDetailPage() {
  const { businessDomainId, successFactorId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [data, setData] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const list = await fetchStrategicIssues(businessDomainId);
        const found = list.find((i) => i.successFactorId === successFactorId);
        setData(found || null);
      } catch (e) { notify.apiError(e); }
    })();
  }, [businessDomainId, successFactorId]);
  if (!data) return null;
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("strategicIssue.detail.title")}</Typography>
        <Button variant="contained" startIcon={<EditIcon />} onClick={() => navigate(`/strategy/${businessDomainId}/strategic-issues/${successFactorId}/edit`)}>{t("common.edit")}</Button>
      </Box>
      <DetailSection>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}><DetailField label={t("successFactor.name")} value={data.successFactorName} /></Grid>
          <Grid item xs={12}><DetailField label={t("common.description")} value={data.successFactorDescription} /></Grid>
          <Grid item xs={12} md={6}><DetailField label={t("businessDomain.name")} value={data.businessDomainName} /></Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
              {t("strategicIssue.sources.label")}
            </Typography>
            {data.sources && data.sources.length > 0 ? (
              <Stack direction="row" flexWrap="wrap" gap={1}>
                {data.sources.map((src) => (
                  <Chip
                    key={src.successFactorId}
                    label={src.successFactorName}
                    variant="outlined"
                    onClick={() => navigate(`/strategy/${businessDomainId}/strategic-issues/${src.successFactorId}`)}
                  />
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">—</Typography>
            )}
          </Grid>
        </Grid>
      </DetailSection>
      <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/strategic-issues`)}>{t("common.back")}</Button>
    </Box>
  );
}
